'use client';

import { Branch } from '@medprev-web-app/api-graphql-client';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import Image from 'next/image';

import { formatBranchName } from '@/utils/formatters/branch';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { EntityAvatar } from '@/components/ui/avatar/entity-avatar';

interface BranchAvatarProps {
  branch: Branch;
}

export const BranchAvatar = ({ branch }: BranchAvatarProps) => {
  const branchName = formatBranchName(branch.name as string);

  return (
    <>
      {branch.avatar
        ? (
            <div
              className="rounded-lg overflow-hidden flex-shrink-0 border border-gray-200"
            >
              <Image
                data-testid={DataTestIdEnum.CITY_BRANCH_LIST_AVATAR}
                src={branch.avatar}
                height={88}
                width={88}
                alt={`Foto de perfil de ${branchName}`}
                draggable={false}
                priority
                unoptimized
                className="object-cover"
              />
            </div>
          )
        : (
            <EntityAvatar
              data-testid={DataTestIdEnum.CITY_BRANCH_LIST_AVATAR_DEFAULT}
              height={88}
              width={88}
              alt={`Foto de perfil de ${branchName}`}
              type={EntityTypeEnum.BRANCH}
            />
          )}
    </>
  );
};
